import 'react-table/react-table.css'
import React, { Component } from 'react'
import {
  FormControl,
  FormHelperText,
  Icon,
  IconButton,
  Input,
  InputAdornment,
  Menu,
  MenuItem,
} from '@material-ui/core'
import { ReactTableDefaults } from 'react-table'
import _ from '@lodash'
import * as R from 'ramda'

const filterTypesForText = [
  {
    value: 'contains',
    title: 'Contains',
  },
  {
    value: 'starts-with',
    title: 'Starts with',
  },
  {
    value: 'ends-with',
    title: 'Ends with',
  },
  {
    value: 'matches',
    title: 'Matches',
  },
]

const filterTypesForNumber = [
  {
    value: 'greater-than',
    title: 'Grater than',
  },
  {
    value: 'less-than',
    title: 'Less than',
  },
]

const FilterForm = React.memo((props) => (
  <div className="filter flex flex-col">
    <FormControl className="">
      <Input
        type="text"
        onChange={props.changeFilterValue}
        value={props.filterValue}
        className="w-full"
        inputProps={{ placeholder: 'Filter' }}
        endAdornment={
          <InputAdornment position="end">
            <IconButton
              aria-owns={props.filterMenuEl ? 'filter-menu' : null}
              aria-haspopup="true"
              onClick={props.handleFilterMenuClick}
            >
              <Icon color="action" className="text-20">
                filter_list
              </Icon>
            </IconButton>
            <Menu
              id="filter-menu"
              anchorEl={props.filterMenuEl}
              open={Boolean(props.filterMenuEl)}
              onClose={props.handleFilterMenuClose}
            >
              {props.filterTypes.map((filter) => (
                <MenuItem
                  key={filter.value}
                  onClick={() => props.changeFilterType(filter.value)}
                >
                  {filter.title}
                </MenuItem>
              ))}
            </Menu>
          </InputAdornment>
        }
      />
      <FormHelperText>
        {_.find(props.filterTypes, { value: props.filterType }).title}
      </FormHelperText>
    </FormControl>
  </div>
))

class FilterComponent extends Component {
  state = {
    filterType: 'contains',
    filterValue: '',
    filterMenuEl: null,
  }
  changeFilterType = (filterType) => {
    const newState = {
      ...this.state,
      filterType,
    }
    // Update local state
    this.setState(newState)
    // Fire the callback to alert React-Table of the new filter
    this.props.onChange(newState)
    this.handleFilterMenuClose()
  }

  changeFilterValue = (event) => {
    const newState = {
      ...this.state,
      filterValue: event.target.value,
    }
    // Update local state
    this.setState(newState)
    // Fire the callback to alert React-Table of the new filter
    this.props.onChange(newState)
  }

  handleFilterMenuClick = (event) => {
    this.setState({ filterMenuEl: event.currentTarget })
  }

  handleFilterMenuClose = () => {
    this.setState({ filterMenuEl: null })
  }

  render() {
    const filterTypes =
      this.props.filterType === 'number'
        ? filterTypesForNumber
        : filterTypesForText
    return (
      <FilterForm
        changeFilterValue={this.changeFilterValue}
        filterValue={this.state.filterValue}
        handleFilterMenuClick={this.handleFilterMenuClick}
        handleFilterMenuClose={this.handleFilterMenuClose}
        changeFilterType={this.changeFilterType}
        filterType={this.state.filterType}
        filterMenuEl={this.state.filterMenuEl}
        filterTypes={filterTypes}
      />
    )
  }
}

const defaultFilterMethod = (filter, row) => {
  const id = filter.pivotId || filter.id
  // Pivoted rows won't contain the column.
  //  If that's the case, we set the to true (allowing us to only filter on the current column)
  if (R.anyPass([R.isNil, R.isEmpty])(R.path(['value', 'filterValue'], filter)))
    return true

  const rowValue = R.unless(R.isNil, R.toLower, row[id])
  if (!rowValue) {
    return false
  }

  const filterValue = filter.value.filterValue.toLowerCase() || ''
  const filterType = filter.value.filterType

  switch (filterType) {
    case 'contains':
      return rowValue.indexOf(filterValue) > -1
    case 'starts-with':
      return rowValue.startsWith(filterValue)
    case 'ends-with':
      return rowValue.endsWith(filterValue)
    case 'matches':
      return rowValue === filterValue
    case 'greater-than':
      return rowValue > filterValue
    case 'less-than':
      return rowValue < filterValue
    default:
      return true
  }
}

/**
 * React Table Defaults
 */
Object.assign(ReactTableDefaults, {
  PreviousComponent: (props) => (
    <IconButton {...props}>
      <Icon>chevron_left</Icon>
    </IconButton>
  ),
  NextComponent: (props) => (
    <IconButton {...props}>
      <Icon>chevron_right</Icon>
    </IconButton>
  ),
  FilterComponent: (props) => <FilterComponent {...props} />,
  defaultFilterMethod,
})
